import {
  createContext,
  MiddlewareFunction,
  Params,
  replace,
} from 'react-router';
import { match, P } from 'ts-pattern';
import { AppState } from '~/stores/app';
import { appStoreContext } from '~/utils/routing';

const isValidShippingClaim = ({
  shippingProtectionClaim,
  params,
}: {
  shippingProtectionClaim: AppState['shippingProtectionClaim'];
  params: Params;
}) =>
  !!shippingProtectionClaim &&
  shippingProtectionClaim.orderIdFromPlatform === params.idFromPlatform &&
  shippingProtectionClaim.status !== 'completed';

export type ShippingProtectionClaim = NonNullable<
  AppState['shippingProtectionClaim']
>;
export const shippingClaimContext = createContext<ShippingProtectionClaim>();

export const shippingClaimMiddleware: MiddlewareFunction = ({
  params,
  context,
}) => {
  const appStore = context.get(appStoreContext);
  const { shippingProtectionClaim } = appStore.getState();

  if (
    !shippingProtectionClaim ||
    !isValidShippingClaim({ shippingProtectionClaim, params })
  ) {
    // clear invalid claim from state to prevent future invalid access before redirecting
    appStore.dispatch(appStore.actions.shippingProtectionClaim.clear());

    const url = match({
      store: params.store,
      status: shippingProtectionClaim?.status,
    })
      // with any invalid reason and we have a store param we can redirect to the crew order hub page
      .with(
        { store: P.string },
        () => `/${params.store}/order/${params.idFromPlatform}`,
      )
      // with a completed claim we can redirect to the look up page to avoid possible loop from the reorder page to claim page
      .with({ status: 'completed' }, () => '/')
      // with any other invalid reason we can redirect to the reorder page
      .otherwise(() => `/reorder/${params.idFromPlatform}`);

    throw replace(url);
  }

  context.set(shippingClaimContext, shippingProtectionClaim);
};
